/* eslint-disable no-useless-catch */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apipost } from '../../service/api';

export const fetchWAconversationsData = createAsyncThunk('fetchWAconversationsData', async () => {
    const userid = sessionStorage.getItem('user_id');
    const userRole = sessionStorage.getItem("userRole");
    try {
        const response = await apipost(`api/whatsapp/messages`);
        return response?.data?.result;
    } catch (error) {
        throw error;
    }
});

const WAconversationSlice = createSlice({
    name: 'WAconversationDetails',
    initialState: {
        data: [],
        isLoading: false,
        error: "",
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWAconversationsData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchWAconversationsData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
                state.error = "";
            })
            .addCase(fetchWAconversationsData.rejected, (state, action) => {
                state.isLoading = false;
                state.data = [];
                state.error = action.error.message;
            });
    },
});

export default WAconversationSlice.reducer;